module.exports = __webpack_public_path__ + "img/ai6.080faadf.png";